module.exports = __webpack_public_path__ + "media/nyan2.c135ed27.mp3";